import { render, staticRenderFns } from "./legal-returnc-case-manage.vue?vue&type=template&id=4ed06da6&scoped=true"
import script from "./legal-returnc-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-returnc-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed06da6",
  null
  
)

export default component.exports